import { components } from "../../../services/api/resourceEvents/types";

export type IResourceEvent = components["schemas"]["IResourceEvent"];

export type EventGroup =
  | {
      type: "single";
      event: IResourceEvent;
    }
  | {
      type: "grouped";
      events: IResourceEvent[];
      actor: string;
      eventType: string;
      eventTitle: string;
      anchorTimestamp: Date;
    };

export const GROUP_WINDOW_MS = 30 * 60 * 1000; // 30 minutes
